import React, { useState, memo, useEffect,useRef } from "react";
import postApiCall from "../Services/postApiCall";
import { decryptBody, encryptData, decrypData } from "../Services/helpers";
import styles from "../css/login-page.module.css";
import PasswordInput from "../Utils/PasswordInput";
import { toast, ToastContainer } from "react-toastify";
import OtpInput from 'react-otp-input';
import { useNavigate, useLocation, useParams } from "react-router-dom";
import ErrorPage from "../Pages/ErrorPage";
import { selectedPartnerDetails } from "../Services/authenticationService";
import { slugifyTransform, migrateSavedAllAccount } from "../Utils/Helpers";
import IsAuthenticat from "../IsAuthenticat";
import getApiCall from "../Services/getApiCall";

function LoginPage({ modalKey, partnerDetails }) {
  const partnerDetailData= partnerDetails?.data;
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const inputRef = useRef(null);
  const otpRequestInProgressRef = useRef(false);
  const otpVerificationInProgressRef = useRef(false);
  const loginRequestInProgressRef = useRef(false);
  const [inputValue, setInputValue] = useState("");
  const [loginType, setLoginType] = useState("null"); // "phone" | "email"
  const [step, setStep] = useState("login");// login | verify | create-password | forgot | forgot-verify
  const [authMode, setAuthMode] = useState("password");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [rePassword, setRePassword] = useState("");
  const [partnerUserId, setPartnerUserId] = useState("");
  const [isReady, setIsReady] = useState(true);
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [error, setError] = useState({}); // inline validation errors
  const [timer, setTimer] = useState(30);
  const [canResend, setCanResend] = useState(false);
  const [resendOtp, setResendOtp] = useState(false)
  const [suggestions, setSuggestions] = useState([]);
  const [rememberMe, setRememberMe] = useState(false);
  const [savedAccounts, setSavedAccounts] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("allAccounts") || "[]");
    } catch {
      return [];
    }
  });
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
  
   const redirectPath = sessionStorage.getItem("redirectAfterLogin") || "/home";
// utils/migrateSavedAccount.js

if(IsAuthenticat()){
  navigate(`/${slugifyTransform(selectedPartnerDetails()?.name)}/home`, { replace: true });
}
  const syncSavedAccounts = (nextAccounts) => {
    setSavedAccounts(nextAccounts);
    localStorage.setItem("allAccounts", JSON.stringify(nextAccounts));
  };

  const removeSavedAccount = (identifier) => {
  const filteredAccounts = savedAccounts.filter(
    (acc) => acc.email !== identifier
  );

  syncSavedAccounts(filteredAccounts);

  setSuggestions((prev) =>
    prev.filter((acc) => acc.email !== identifier)
  );

  if (inputValue === identifier) {
    setInputValue("");
    setPassword("");
    setRememberMe(false);
    setLoginType(null);
  }

  toast.success("Saved credential deleted");
};

  const removeAllSavedAccounts = () => {
    syncSavedAccounts([]);
    setSuggestions([]);
    setInputValue("");
    setLoginType(null);
  };
  // detect login type
  const handleInputChange = (e) => {
    let val = e.target.value.trim();

    if (/^\d+$/.test(val)) {
      // allow only 10 digits for phone
      val = val.slice(0, 10);
      setLoginType("phone");
    } else if (/\S+@\S+\.\S+/.test(val)) {
      setLoginType("email");
    } else {
      setLoginType(null);
    }
 const matches = savedAccounts.filter((acc) =>
      acc.email.toLowerCase().includes(val.toLowerCase())
    );
    console.log('matches:::::',matches)
    setSuggestions(val ? matches : []);
    setInputValue(val);
  };
    console.log('suggestions:::::11111111',suggestions, IsAuthenticat())

  // const selectSuggestion = (acc) => {
  //   setInputValue(acc.email);

  //   if (
  //     acc?.rememberMe &&
  //     acc?.password
  //   ) {
  //     setPassword(decrypData(acc.password));
  //     setRememberMe(true);
  //   } else {
  //     setPassword("");
  //     setRememberMe(false);
  //   }

  //   setLoginType("email");
  //   setSuggestions([]);
  // };

  const selectSuggestion = (acc) => {
  setInputValue(acc.email);

  if (acc?.rememberMe && acc?.password) {
    setPassword(decrypData(acc.password));
    setRememberMe(true);
  } else {
    setPassword("");
    setRememberMe(false);
  }

  // Detect type correctly
  if (/^\d{10}$/.test(acc.email)) {
    setLoginType("phone");
  } else {
    setLoginType("email");
  }

  setSuggestions([]);
};


  const checkPasswordGenerated = async () => {
  try {
    const data = await getApiCall(
      `admin/is-password-generated?email_mobile=${inputValue}`,
      {},
    );

    return data;
  } catch (error) {
    throw error;
  }
};

  useEffect(()=>{
migrateSavedAllAccount()
  },[])
  useEffect(() => {
    setInputValue("");
    setLoginType(null);
    setAuthMode("password");
    setOtp("");
    setPassword("");
    setNewPassword("");
    setRePassword("");
    setPartnerUserId("");
    setError({});
    setStep('login')
  }, [modalKey]);

  // Send OTP or Continue (for email)
  const sendOtpOrContinue = async (e) => {
    e.preventDefault();
    setError({});
    if (!inputValue) return setError({ input: "Email or Phone is required" });
    if (!loginType) return setError({ input: "Enter valid email or phone" });
    if (!isReady) return;

    setIsReady(false);

    try {

      const response = await checkPasswordGenerated();

      if (!response?.meta?.status) {

        toast.error(
          response?.meta?.msg ||
          "Unable to validate user"
        );

        return;
      }

      if (response?.data?.isPasswordRequired) {

        // PASSWORD ALREADY CREATED
        setAuthMode("password");
        setStep("verify");

      } else {

        // FIRST TIME LOGIN
        setStep("create-password");

      }

    } catch (error) {

      toast.error(
        error?.response?.data?.meta?.msg ||
        "Something went wrong"
      );

    } finally {

      setIsReady(true);

    }
  };


  const loginWithOtp = async () => {
    if (otpRequestInProgressRef.current) return;

    otpRequestInProgressRef.current = true;
    setIsSendingOtp(true);

    const obj =
      loginType === "email"
        ? {
            type: 1,
            email: inputValue,
          }
        : {
            type: 2,
            mobile: inputValue,
          };

    try {
      const data = await postApiCall("admin/sendOTP", obj);

      if (data.meta.status) {
        const decryptUserId = decryptBody(data.data);

        setPartnerUserId(decryptUserId.userId);
        setAuthMode("otp");
        setStep("verify");
        setResendOtp(prev => !prev);
        toast.success(data.meta.msg);
      } else {
        toast.error(data.meta.msg);
      }
    } catch (err) {
      toast.error(
        err?.response?.data?.meta?.msg ||
        "Something went wrong!"
      );
    } finally {
      otpRequestInProgressRef.current = false;
      setIsSendingOtp(false);
    }
  };

  // Verify OTP or Password
  const verifyOtpOrPassword = async (e) => {
    e.preventDefault();
    if (authMode === "otp" && otpVerificationInProgressRef.current) return;
    if (authMode !== "otp" && loginRequestInProgressRef.current) return;

    setError({});
    let payload = { partnerUserId, type: loginType === "phone" ? 2 : 1, partnerId: partnerDetailData?._id };

    // if (loginType === "phone") {
    if (authMode === "otp") {
      if (!otp) return setError({ otp: "OTP is required" });
      otpVerificationInProgressRef.current = true;
      setIsVerifyingOtp(true);
      payload.otp = otp;
      // payload.phone = inputValue
    } else {
      if (!password) {
        return setError({ password: "Password is required" });
      }

      if (!passwordRegex.test(password)) {
        return setError({
          password:
            "Password must be at least 8 characters, include uppercase, lowercase, number, and special character",
        });
      }

      payload = {
        ...payload,
        password,
        partnerId: partnerDetailData?._id,
      };

      delete payload.partnerUserId;
      payload["email_mobile"] = inputValue;

      loginRequestInProgressRef.current = true;
      setIsLoggingIn(true);

      try {
        const data = await postApiCall("admin/login", payload);

        if (data?.meta?.status) {
          const existingIndex = savedAccounts.findIndex(
            (a) => a.email === inputValue
          );

          let updatedAccounts = [...savedAccounts];

          if (rememberMe) {
            const accountData = {
              email: inputValue,
              password: encryptData(password),
              rememberMe: true,
            };

            if (existingIndex >= 0) {
              updatedAccounts[existingIndex] = accountData;
            } else {
              updatedAccounts.push(accountData);
            }

            syncSavedAccounts(updatedAccounts);
          } else {
            // User unchecked Remember Me
            updatedAccounts = savedAccounts.map((acc) =>
              acc.email === inputValue
                ? {
                  ...acc,
                  password: "",
                  rememberMe: false,
                }
                : acc
            );

            syncSavedAccounts(updatedAccounts);
          }

          const { token, ...userData } = data.data;

          sessionStorage.removeItem("redirectAfterLogin");
          localStorage.setItem("loginDetails", token);
          localStorage.setItem("userDetails", JSON.stringify(userData));

          const filteredPartner = userData?.partnerDetails.find(
            (partner) => partner._id === userData.partnerId
          );

          localStorage.setItem(
            "selectedPartner",
            JSON.stringify(filteredPartner ? filteredPartner : userData?.partnerDetails[0])
          );

          window.location.href =
            `${slugifyTransform(
              filteredPartner
                ? filteredPartner?.name
                : userData?.partnerDetails[0]?.name
            ) + redirectPath}`;

        } else {
          toast.error(data?.meta?.msg || "Login failed", {
            toastId: data?.meta?.msg || "login-failed",
          });
        }
      } catch (error) {
        console.error("Login API Error:", error);

        toast.error(
          error?.response?.data?.meta?.msg ||
          error?.message ||
          "Something went wrong. Please try again.",
          {
            toastId: "login-api-error",
          }
        );
      } finally {
        loginRequestInProgressRef.current = false;
        setIsLoggingIn(false);
      }

      return;
    }

    try {
      const data = await postApiCall("admin/verifyOTP", payload);
      if (data.meta.status) {
        // ✅ Never store password
        const { token, ...userData } = data.data;
        // ✅ Use localStorage for sensitive session data
        localStorage.setItem("loginDetails", token);
        localStorage.setItem("userDetails", JSON.stringify(userData));
        localStorage.setItem("selectedPartner", JSON.stringify(userData?.partnerDetails[0]))

        // window.location.href = "/home";
        window.location.href = `${slugifyTransform(userData?.partnerDetails[0].name) + redirectPath}`;
      } else {
        toast.error(data?.meta?.msg || "OTP verification failed");
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.meta?.msg ||
        error?.message ||
        "Something went wrong while verifying OTP"
      );
    } finally {
      otpVerificationInProgressRef.current = false;
      setIsVerifyingOtp(false);
    }
  };

  // Forgot password flow
  const handleForgotPassword = async (e, type = "send") => {
    e.preventDefault();
    setError({});
    if (!inputValue)
  return setError({ input: "Email or Mobile is required" });
    // if (!/\S+@\S+\.\S+/.test(inputValue))
    //   return setError({ input: "Enter a valid email" });
    const isEmail = /\S+@\S+\.\S+/.test(inputValue);
const isMobile = /^\d{10}$/.test(inputValue);

if (!isEmail && !isMobile) {
  return setError({
    input: "Enter a valid email or mobile number",
  });
}


    if (!newPassword) return setError({ newPassword: "New password required" });
    if (!passwordRegex.test(newPassword)) {
      return setError({
        newPassword:
          "New Password must be at least 8 characters, include uppercase, lowercase, number, and special character",
      });
    }
    if (!rePassword) return setError({ rePassword: "Please retype password" });
    if (newPassword !== rePassword)
      return setError({ rePassword: "Passwords do not match" });

    let obj = {
  email_mobile: inputValue,
  password: newPassword,
  confirmPassword: rePassword,
};
    try {
      const data = await postApiCall("admin/reset-password-otp", obj);
      if (data.meta.status) {
        if (type !== "resend") {
          setStep("forgot-verify");
        } else {
          setResendOtp(!resendOtp)
        }
        toast.success(data.meta.msg);
      } else {
        toast.error(data.meta.msg);
      }
    } catch {
      console.log('errrrr catchhhh::::')
      toast.error("Something went wrong!");
    }
  };

  const resetPassword = async (e) => {
    e.preventDefault();
    if (!otp) return setError({ otp: "OTP is required" });

    let payload = {
  email_mobile: inputValue,
  otp: Number(otp),
  password: newPassword,
};

    try {
      const data = await postApiCall("admin/reset-password", payload);
      if (data.meta.status) {
        toast.success(data.meta.msg);
        // reset all state
        setStep("login");
        // setInputValue("");
        setPassword("");
        setNewPassword("");
        setRePassword("");
        setOtp("");
        setError({});
      } else {
        toast.error(data.meta.msg);
      }
    } catch {
      toast.error("Something went wrong!");
    }
  };

  const createFirstTimePassword = async (e) => {
  e.preventDefault();

  setError({});

  if (!newPassword) {
    return setError({
      newPassword: "New Password is required",
    });
  }

  if (!passwordRegex.test(newPassword)) {
    return setError({
      newPassword:
        "Password must be at least 8 characters, include uppercase, lowercase, number, and special character",
    });
  }

  if (!rePassword) {
    return setError({
      rePassword: "Please re-enter password",
    });
  }

  if (newPassword !== rePassword) {
    return setError({
      rePassword: "Passwords do not match",
    });
  }

  const payload = {
    email_mobile: inputValue,
    password: newPassword,
    confirmPassword: rePassword,
  };

  try {

  const data = await postApiCall(
    "admin/reset-password-otp",
    payload
  );

  if (data.meta.status) {
    toast.success(data.meta.msg);
    setStep("create-password-verify");
  } else {
    toast.error(data.meta.msg);
  }

} catch (error) {

  toast.error(
    error?.response?.data?.meta?.msg ||
    "Something went wrong!"
  );

}
};

const verifyFirstTimePasswordOtp = async (e) => {
  e.preventDefault();

  if (!otp) {
    return setError({
      otp: "OTP is required",
    });
  }

  const payload = {
    email_mobile: inputValue,
    otp: Number(otp),
    password: newPassword,
  };

  try {

    const data = await postApiCall(
      "admin/reset-password",
      payload
    );

    if (data.meta.status) {

      toast.success(data.meta.msg);

      setOtp("");
      setNewPassword("");
      setRePassword("");
      setError({});

      // Back to Login
      setStep("login");

    } else {

      toast.error(data.meta.msg);

    }

  } catch {

    toast.error("Something went wrong!");

  }
};

  const handleEditPhonEmail = () => {
    setStep("login");
    setPassword('')
    setNewPassword('')
    setRePassword('')
    setOtp('')
  }

  const formatMobile = (num) => {
  if (!num) return "";
  // Ensure it's only digits
  num = num.toString().replace(/\D/g, "");
  // Apply your pattern: XX-XX75-9723
  return `XX-XX${num.slice(4, 6)}-${num.slice(6)}`;
  };

const maskEmail = (email) => {
  if (!email) return "";
  const [user, domain] = email.split("@");
  // If username is shorter than 3 chars, show only first char
  const visible = user.slice(0, 3);
  return `${visible}***@${domain}`;
};
const maskMobile = (mobile) => {
  if (!mobile) return "";

  return `+91- XXXXXX${mobile.slice(-4)}`;
};



useEffect(() => {
  if (
    (step === "verify" && authMode === "otp") ||
    step === "forgot-verify" ||
    step === "create-password-verify"
  ) {
    setTimer(30);
    setCanResend(false);

    const interval = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          setCanResend(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }
}, [step, authMode, resendOtp]);

  useEffect(() => {
  if (step === "login") {
    setTimeout(() => {
      inputRef.current?.focus();
    }, 100);
  }
}, [step]);

useEffect(() => {
  const account = savedAccounts.find(
    (acc) => acc.email === inputValue
  );

  if (account?.rememberMe && account?.password) {
    setPassword(decrypData(account.password));
    setRememberMe(true);
  } else {
    setRememberMe(false);
    // Don't touch password here
  }
}, [inputValue, savedAccounts]);

const resendForgotPasswordOtp = async () => {
  try {
    const payload = {
      email_mobile: inputValue,
      password: newPassword,
      confirmPassword: rePassword,
    };

    const data = await postApiCall(
      "admin/reset-password-otp",
      payload
    );

    if (data.meta.status) {
      toast.success(data.meta.msg);
      setResendOtp(prev => !prev);
    } else {
      toast.error(data.meta.msg);
    }
  } catch (error) {
    toast.error(
      error?.response?.data?.meta?.msg ||
      "Something went wrong!"
    );
  }
};


  console.log("partnerDetails = ",partnerDetailData);
  

  return (
  <div className={styles["login-page"]}>
    {partnerDetails?.meta?.status ? (
      <div className={styles["login-layout"]}>

        {/* =====================================================
            LEFT / HERO SECTION
            Desktop = Left side
            Mobile = Main background page
        ===================================================== */}

        <div className={styles["hero-section"]}>

          {/* Logo */}

          <div className={styles["hero-logo-wrapper"]}>
            {partnerDetailData?.logo ? (
              <img
                src={partnerDetailData.logo}
                alt={`${partnerDetailData?.name || "Branch Company"} Logo`}
                className={styles["hero-logo"]}
              />
            ) : (
              <div className={styles["hero-logo-text"]}>
                <span>One</span> Home
              </div>
            )}
          </div>


          {/* Hero Content */}

          <div className={styles["hero-content"]}>

            <p className={styles["hero-small-text"]}>
              {!partnerDetailData?.title && "One Place Auction"}
            </p>

            <h1 className={styles["hero-title"]}>
              {partnerDetailData?.title ? (
                partnerDetailData.title
              ) : (
                <>
                  Simplified
                  <br />
                  Real Estate Auctions!
                </>
              )}
            </h1>

            <p className={styles["hero-description"]}>
              {partnerDetailData?.description ? (
                partnerDetailData.description
              ) : (
                <>
                  Effortless Property Management!
                  <br />
                  Manage your real estate auctions seamlessly with our
                  intuitive platform.
                </>
              )}
            </p>

          </div>

        </div>


        {/* =====================================================
            RIGHT / LOGIN SECTION
            Desktop = Center card
            Mobile = Bottom sheet
        ===================================================== */}

        <div className={styles["login-section"]}>

          <div className={styles["login-card"]}>

            {/* Mobile bottom sheet handle */}

            <div className={styles["sheet-handle"]}></div>


            {/* =================================================
                LOGO
            ================================================= */}

            <div className={styles["login-card-logo-wrapper"]}>

              {partnerDetailData?.logo ? (
                <img
                  src={partnerDetailData.logo}
                  alt={`${partnerDetailData?.name || "Branch Company"} Logo`}
                  className={styles["login-logo"]}
                />
              ) : (
                <div className={styles["login-logo-text"]}>
                  <span>One</span> Home
                </div>
              )}

            </div>


            {/* =================================================
                HEADING
            ================================================= */}

            {step === "login" && (
              <>
                <h2 className={styles["login-heading"]}>
                  Welcome Back
                </h2>

                <p className={styles["login-subheading"]}>
                  Sign in to continue to{" "}
                  {partnerDetailData?.name || "Branch Company"}
                </p>
              </>
            )}


            {/* =================================================
                VERIFY / FORGOT HEADER
            ================================================= */}

          {step !== "login" &&
 step !== "create-password" &&
 step !== "create-password-verify" && (
              <div className={styles["inner-header"]}>

                <button
                  type="button"
                  className={styles["back-button"]}
                  onClick={() => {
                    setStep("login");
                    setError({});
                    setNewPassword("");
                    setRePassword("");
                    setOtp("");
                  }}
                >
                  <i className="bi bi-arrow-left"></i>
                </button>


                <div>
                  <h2 className={styles["inner-heading"]}>
                      {
                        step === "verify"
                          ? authMode === "otp"
                            ? "OTP Verification"
                            : "Password Verification"
                          : step === "forgot"
                            ? "Forgot Password"
                            : step === "create-password-verify"
                              ? "Verify Password Setup OTP"
                              : "Verify OTP"
                      }
                  </h2>
                </div>

              </div>
            )}


            {/* =================================================
                LOGIN
            ================================================= */}

            {step === "login" && (

              <form
                onSubmit={sendOtpOrContinue}
                className={styles["form-container"]}
              >

                {/* Email / Mobile */}

                <div className={styles["form-group"]}>

                  <label className={styles["form-label"]}>
                    Email ID / Mobile Number
                  </label>


                  <div className={styles["input-area"]}>

                    <div
                      className={
                        loginType === "phone"
                          ? styles["phone-input-group"]
                          : styles["input-wrapper"]
                      }
                    >

                      <i
                        className={`bi ${
                          loginType === "phone"
                            ? "bi-phone"
                            : "bi-envelope"
                        } ${styles["input-icon"]}`}
                      ></i>


                      {loginType === "phone" && (
                        <span className={styles["country-code"]}>
                          +91
                        </span>
                      )}


                      <input
                        ref={inputRef}
                        type="text"
                        inputMode={
                          loginType === "phone"
                            ? "numeric"
                            : "email"
                        }
                        className={`${styles["login-input"]} ${
                          loginType === "phone"
                            ? styles["phone-input"]
                            : ""
                        }`}
                        placeholder="Enter Email ID / Mobile No."
                        value={inputValue}
                        maxLength={
                          loginType === "phone"
                            ? 10
                            : undefined
                        }
                        onChange={handleInputChange}
                        required
                        autoFocus
                        autoComplete="email"
                      />

                    </div>


                    {/* =========================================
                        SAVED ACCOUNTS
                    ========================================= */}

                    {suggestions.length > 0 && (
                      <>
                        <button
                          type="button"
                          className={styles["saved-accounts-backdrop"]}
                          aria-label="Close saved accounts"
                          onClick={() => setSuggestions([])}
                        />
                        <div className={styles["saved-accounts"]}>

                        <div
                          className={
                            styles["saved-accounts-header"]
                          }
                        >

                          <span
                            className={
                              styles["saved-accounts-title"]
                            }
                          >
                            Choose an account
                          </span>


                          <button
                            type="button"
                            className={
                              styles["remove-all-button"]
                            }
                            onClick={removeAllSavedAccounts}
                          >
                            Remove all
                          </button>

                          <button
                            type="button"
                            className={styles["saved-accounts-close"]}
                            aria-label="Close saved accounts"
                            onClick={() => setSuggestions([])}
                          >
                            <i className="bi bi-x-lg"></i>
                          </button>

                        </div>


                        {suggestions.map((acc, i) => (

                          <div
                            key={i}
                            className={styles["saved-account"]}
                            onClick={() =>
                              selectSuggestion(acc)
                            }
                          >

                            <div
                              className={
                                styles["saved-account-avatar"]
                              }
                            >
                              {acc.email
                                ?.charAt(0)
                                ?.toUpperCase()}
                            </div>


                            <div
                              className={
                                styles["saved-account-details"]
                              }
                            >

                              <div
                                className={
                                  styles["saved-account-email"]
                                }
                              >
                                {acc.email}
                              </div>

                              <div
                                className={
                                  styles["saved-account-label"]
                                }
                              >
                                Saved account
                              </div>

                            </div>


                            <button
                              type="button"
                              className={
                                styles["remove-account-button"]
                              }
                              aria-label={`Remove ${acc.email}`}
                              onClick={(e) => {
                                e.stopPropagation();
                                removeSavedAccount(acc.email);
                              }}
                            >
                              <i className="bi bi-trash"></i>
                            </button>

                          </div>

                        ))}

                      </div>
                      </>
                    )}

                  </div>


                  {error.input && (
                    <small className={styles["error-text"]}>
                      {error.input}
                    </small>
                  )}

                </div>


                {/* Continue */}

                <button
                  className={styles["login-button"]}
                  type="submit"
                  disabled={!isReady}
                >
                  {loginType === "phone"
                    ? "Continue"
                    : "Continue"}
                </button>

              </form>

            )}


            {/* =================================================
                VERIFY
            ================================================= */}

              {step === "verify" && (

                <form
                  onSubmit={verifyOtpOrPassword}
                  className={styles["form-container"]}
                >

                  <p className={styles["verify-description"]}>
                    {authMode === "otp"
                      ? `Enter the 6-digit OTP we sent to ${inputValue}`
                      : loginType === "phone"
                        ? `Please enter your password to continue with ${inputValue}`
                        : `Please enter your password to continue with ${inputValue}`}
                  </p>


                  {/* {loginType === "phone" ? ( */}
                  {authMode === "otp" ? (

                    <>

                      <label className={styles["form-label"]}>
                        Enter OTP
                      </label>

                      <OtpInput
                        value={otp}
                        onChange={setOtp}
                        numInputs={6}
                        containerStyle={styles.otpWrapper}
                        renderInput={(props, index) => (
                          <input
                            {...props}
                            className={styles.otpInput}
                            autoFocus={index === 0}
                          />
                        )}
                      />

                      {error.otp && (
                        <small className={styles["error-text"]}>
                          {error.otp}
                        </small>
                      )}


                      {/* <div
                      className={
                        styles["resend-container"]
                      }
                    >

                      {!canResend ? (

                        <small className="text-muted">
                          Resend OTP in {timer}s
                        </small>

                      ) : (

                        <button
                          type="button"
                          className={
                            styles["resend-button"]
                          }
                          onClick={async () => {

                            const obj = {
                              type: 2,
                              mobile: inputValue,
                            };

                            try {

                              const data =
                                await postApiCall(
                                  "admin/sendOTP",
                                  obj
                                );

                              if (data.meta.status) {

                                toast.success(
                                  data.meta.msg
                                );

                                setResendOtp(
                                  !resendOtp
                                );

                              } else {

                                toast.error(
                                  data.meta.msg
                                );

                              }

                            } catch {

                              toast.error(
                                "Something went wrong!"
                              );

                            }

                          }}
                        >
                          Resend OTP
                        </button>

                      )}

                    </div> */}

                      <div className={styles["resend-container"]}>

                        <button
                          type="button"
                          className={styles["resend-button"]}
                          onClick={() => {
                            setAuthMode("password");
                            setOtp("");
                          }}
                        >
                          Login with Password
                        </button>

                        {!canResend ? (
                          <small className="text-muted">
                            Resend OTP in {timer}s
                          </small>
                        ) : (
                          <button
                            type="button"
                            className={styles["resend-button"]}
                            onClick={loginWithOtp}
                          >
                            Resend OTP
                          </button>
                        )}


                      </div>

                    </>

                  ) : (

                    <>

                      <PasswordInput
                        placeholder="Enter Password"
                        value={password}
                        onChange={(e) =>
                          setPassword(e.target.value)
                        }
                        error={error.password || ""}
                      />


                      {/* <div
                      className={
                        styles["forgot-password-wrapper"]
                      }
                    >

                      <button
                        type="button"
                        className={
                          styles["forgot-password-button"]
                        }
                        onClick={() =>
                          setStep("forgot")
                        }
                      >
                        Forgot Password?
                      </button>

                    </div> */}

                      <div className={styles["auth-options-wrapper1"]}>
                        <label className={styles["remember-me"]}>
                          <input
                            type="checkbox"
                            checked={rememberMe}
                            onChange={(e) => {
                              const checked = e.target.checked;

                              setRememberMe(checked);

                              if (!checked) {
                                const updatedAccounts = savedAccounts.map((acc) =>
                                  acc.email === inputValue
                                    ? {
                                      ...acc,
                                      // password: "",
                                      rememberMe: false,
                                    }
                                    : acc
                                );

                                syncSavedAccounts(updatedAccounts);
                              }
                            }}
                          />
                          <span>Remember me</span>
                        </label>
                      </div>




                      <div className={styles["auth-links-wrapper"]}>
                          <button
                            type="button"
                            className={styles["forgot-password-button"]}
                            onClick={loginWithOtp}
                            disabled={isSendingOtp}
                          >
                            {isSendingOtp ? "Sending OTP..." : "Login with OTP"}
                          </button>

                        <button
                          type="button"
                          className={styles["forgot-password-button"]}
                          onClick={() => setStep("forgot")}
                        >
                          Forgot Password?
                        </button>
                      </div>

                    </>

                  )}


                  <button
                    className={styles["login-button"]}
                    type="submit"
                    disabled={
                      authMode === "otp"
                        ? isVerifyingOtp
                        : isLoggingIn
                    }
                  >
                    {authMode === "otp"
                      ? (isVerifyingOtp ? "Verifying..." : "Verify OTP")
                      : (isLoggingIn ? "Logging in..." : "Login")}
                  </button>

                </form>

              )}


            {step === "create-password" && (
  <form
    onSubmit={createFirstTimePassword}
    className={styles["form-container"]}
  >
    <h2 className={styles["login-heading"]}>
      Create Password
    </h2>

    <p className={styles["verify-description"]}>
      Create your password to continue.
    </p>

    <PasswordInput
      label="New Password"
      placeholder="Enter New Password"
      value={newPassword}
      onChange={(e) => setNewPassword(e.target.value)}
      error={error.newPassword || ""}
    />

    <PasswordInput
      label="Re-Enter Password"
      placeholder="Re-Enter Password"
      value={rePassword}
      onChange={(e) => setRePassword(e.target.value)}
      error={error.rePassword || ""}
    />

    <button
      className={styles["login-button"]}
      type="submit"
    >
      Send OTP
    </button>
  </form>
)}

{step === "create-password-verify" && (
  <form
    onSubmit={verifyFirstTimePasswordOtp}
    className={styles["form-container"]}
  >
    <h2 className={styles["login-heading"]}>
      Verify OTP
    </h2>

    <p className={styles["verify-description"]}>
      Enter OTP sent to {inputValue}
    </p>

    <OtpInput
      value={otp}
      onChange={setOtp}
      numInputs={6}
      containerStyle={styles.otpWrapper}
      renderInput={(props) => (
        <input
          {...props}
          className={styles.otpInput}
        />
      )}
    />

    {error.otp && (
      <small className={styles["error-text"]}>
        {error.otp}
      </small>
    )}

    <button
      type="submit"
      className={styles["login-button"]}
    >
      Verify OTP
    </button>
  </form>
)}
            {/* =================================================
                FORGOT PASSWORD
            ================================================= */}

            {step === "forgot" && (

              <form
                onSubmit={(e) =>
                  handleForgotPassword(e, "send")
                }
                className={styles["form-container"]}
              >

                {/* <div className={styles["form-group"]}>

                  <label className={styles["form-label"]}>
                    Email/Mobile Number
                  </label>

                  <div className={styles["input-wrapper"]}>

                    <i
                      className={`bi bi-envelope ${styles["input-icon"]}`}
                    ></i>

                    <input
                      className={styles["login-input"]}
                      value={inputValue}
                      onChange={handleInputChange}
                      placeholder="Enter Email ID"
                    />

                  </div>


                  {error.input && (
                    <small className={styles["error-text"]}>
                      {error.input}
                    </small>
                  )}

                </div> */}
                  <p className={styles["verify-description"]}>
                    Reset password for <strong>{inputValue}</strong>
                  </p>


                <PasswordInput
                  placeholder="New Password"
                  label="New Password"
                  value={newPassword}
                  onChange={(e) =>
                    setNewPassword(e.target.value)
                  }
                  error={error.newPassword || ""}
                />


                <PasswordInput
                  placeholder="Re-Enter Password"
                  label="Re-Enter Password"
                  value={rePassword}
                  onChange={(e) =>
                    setRePassword(e.target.value)
                  }
                  error={error.rePassword || ""}
                />


                <button
                  className={styles["login-button"]}
                  type="submit"
                >
                  Send OTP
                </button>

              </form>

            )}


            {/* =================================================
                FORGOT PASSWORD OTP
            ================================================= */}

            {step === "forgot-verify" && (

              <form
                onSubmit={resetPassword}
                className={styles["form-container"]}
              >

                <div className={styles["form-group"]}>

                  <label className={styles["form-label"]}>
                    Email
                  </label>

                  <div className={styles["input-wrapper"]}>

                    <i
                      className={`bi bi-envelope ${styles["input-icon"]}`}
                    ></i>

                    <input
                      className={styles["login-input"]}
                      value={inputValue}
                      disabled
                    />

                  </div>

                </div>


                <div className={styles["form-group"]}>

                  <label className={styles["form-label"]}>
                    Enter OTP
                  </label>

                  <OtpInput
                    value={otp}
                    onChange={setOtp}
                    numInputs={6}
                    containerStyle={styles.otpWrapper}
                    renderInput={(props) => (
                      <input
                        {...props}
                        className={styles.otpInput}
                      />
                    )}
                  />

                  {error.otp && (
                    <small className={styles["error-text"]}>
                      {error.otp}
                    </small>
                  )}

                </div>


               <div className={styles["resend-container"]}>

  <button
    type="button"
    className={styles["resend-button"]}
    onClick={() => {
      setAuthMode("password");
      setOtp("");
    }}
  >
    Login with Password
  </button>

  {!canResend ? (
    <small className="text-muted">
      Resend OTP in {timer}s
    </small>
  ) : (
    <button
      type="button"
      className={styles["resend-button"]}
      onClick={resendForgotPasswordOtp}
    >
      Resend OTP
    </button>
  )}

</div>


                <button
                  className={styles["login-button"]}
                  type="submit"
                >
                  Reset Password
                </button>

              </form>

            )}

          </div>

        </div>

      </div>
    ) : (
      <ErrorPage />
    )}

    <ToastContainer
      position="top-right"
      style={{ top: "57px" }}
    />
  </div>
);
}

export default LoginPage;
